import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import MuiBox from '@mui/system/Box';
import AutoSizer from 'react-virtualized-auto-sizer';
import './components/EllipsisMenu.js';
import './components/BreadcrumbOption.js';
import './components/BreadcrumbMock.js';
import InternalBreadcrumbs from './components/InternalBreadcrumbs.js';

const Root = styled(MuiBox) `
  width: 100%;
`;
const Breadcrumbs = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return (jsx(Root, Object.assign({ className: className }, { children: jsx(AutoSizer, Object.assign({ disableHeight: true }, { children: ({ width }) => jsx(InternalBreadcrumbs, Object.assign({ width: width }, rest)) })) })));
};

export { Breadcrumbs as default };
//# sourceMappingURL=Breadcrumbs.js.map
